<template>
  <div>
    <h2 class="h2  text-light">Datum en tijd</h2>
    <h1 class="h1">Selecteer een tijdvak</h1>
    <div class="card">
      <div class="row-2">
        <div class="row-1">
          <div class="form-group">
            <label>Is de ophaaldag hetzelfde als de afleverdag?</label>
            <select v-model="zelfdedag" name="zelfdedag">
              <option disabled value="">Selecteer een optie</option>
              <option value="ja"
                >Ja, de ophaaldag is hetzelfde als de afleverdag</option
              >
              <option value="nee"
                >Nee, de ophaaldag is anders dan de afleverdag</option
              >
            </select>
          </div>
          <div class="form-group info">
            <p>
              <b>Opslagservice</b><br />
              Indien de afleverdag niet hetzelfde is als de ophaaldag dan maakt
              u automatisch gebruik van onze opslagservice. Aan onze
              opslagservice zijn kosten verbonden. Deze kosten zijn afhankelijk
              van het aantal dagen.
            </p>

            <p v-if="typeTransport !== 'verhuizing'">
              <b>Bezorging</b><br />
              Bij flexibel hoor je één dag van te voren in welk tijdvak van 4
              uur we langskomen.
            </p>
            <p v-else>
              <b>Voorwaarden</b><br />
              Een verhuizing duurt meestal een gehele dag, we zullen om deze
              reden rond 9 uur 's ochtends beginnen.
            </p>

            <p v-if="typeTransport === 'verhuizing'">
              <b>Spoed</b><br />
              Indien het gaat om een spoedgeval die binnen 2 dagen verzorgd
              dient te worden, neem contact op met onze klantenservice.
            </p>
            <p v-else>
              <b
                >Wanneer u een opdracht plaatst, regelen wij uw bezorging
                (gegarandeerd) binnen 24 uur.</b
              >
            </p>
          </div>
        </div>
        <div>
          <div
            class="form-group"
            :class="{
              'form-error': !$v.ophalendatum.required && $v.ophalendatum.$error
            }"
          >
            <label for="objectType" v-if="zelfdedag !== 'ja'"
              >Ophaaldatum</label
            >
            <label for="objectType" v-else>Ophaal- en afleverdatum</label>
            <flat-pickr
              v-model="ophalendatum"
              :config="flatpickrConfig"
            ></flat-pickr>
            <select
              v-if="typeTransport !== 'verhuizing'"
              v-model="ophalenTime"
              class="mt-2"
              name="ophalenTime"
            >
              <option disabled value="" selected>Selecteer een optie</option>
              <option value="flex"
                >Flexibel tussen 9:00 en 18:00 (+€0,-)</option
              >
              <option value="09:00-13:00">09:00 - 13:00 (+€10,-)</option>
              <option value="10:00-14:00">10:00 - 14:00 (+€10,-)</option>
              <option value="11:00-15:00">11:00 - 15:00 (+€10,-)</option>
              <option value="12:00-16:00">12:00 - 16:00 (+€10,-)</option>
              <option value="13:00-17:00">13:00 - 17:00 (+€10,-)</option>
              <option value="14:00-18:00">14:00 - 18:00 (+€10,-)</option>
              <option value="15:00-19:00">15:00 - 19:00 (+€10,-)</option>
              <option value="16:00-20:00">16:00 - 20:00 (+€10,-)</option>
              <option value="17:00-21:00">17:00 - 21:00 (+€10,-)</option>
              <option value="18:00-22:00">18:00 - 22:00 (+€10,-)</option>
            </select>
          </div>
          <div
            v-if="zelfdedag !== 'ja'"
            class="form-group mt-2"
            :class="{
              'form-error': !$v.afleverdatum.required && $v.afleverdatum.$error
            }"
          >
            <label for="objectType">Afleverdatum</label>
            <flat-pickr
              v-model="afleverdatum"
              :config="flatpickrConfig"
            ></flat-pickr>
            <select
              v-if="typeTransport !== 'verhuizing'"
              v-model="afleverTime"
              class="mt-2"
              name="afleverTime"
            >
              <option disabled value="" selected>Selecteer een optie</option>
              <option value="flex"
                >Flexibel tussen 9:00 en 18:00 (+€0,-)</option
              >
              <option value="09:00-13:00">09:00 - 13:00 (+€10,-)</option>
              <option value="10:00-14:00">10:00 - 14:00 (+€10,-)</option>
              <option value="11:00-15:00">11:00 - 15:00 (+€10,-)</option>
              <option value="12:00-16:00">12:00 - 16:00 (+€10,-)</option>
              <option value="13:00-17:00">13:00 - 17:00 (+€10,-)</option>
              <option value="14:00-18:00">14:00 - 18:00 (+€10,-)</option>
              <option value="15:00-19:00">15:00 - 19:00 (+€10,-)</option>
              <option value="16:00-20:00">16:00 - 20:00 (+€10,-)</option>
              <option value="17:00-21:00">17:00 - 21:00 (+€10,-)</option>
              <option value="18:00-22:00">18:00 - 22:00 (+€10,-)</option>
            </select>
          </div>

          <p class="mt-2" v-if="zelfdedag !== 'ja'">
            <b>Let op:</b> De afleverdatum is 2 dagen later dan de ophaaldatum.
            Zie het prijsoverzicht voor de berekende meerprijs voor onze
            opslagservice.
          </p>
        </div>
      </div>
      <div
        class="error"
        v-if="$v.ophalendatum.$error || $v.afleverdatum.$error"
      >
        Beide datums dienen ingevuld te worden.
      </div>
    </div>
    <button @click="nextStep" class="btn btn__filled w-100">
      Volgende
    </button>
    <button
      @click="goToPreviousRoute"
      class="btn btn__simple btn__left btn__backbt"
    >
      <i class="fas fa-chevron-left"></i> Terug
    </button>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Dutch } from "flatpickr/dist/l10n/nl.js";
import { required, requiredIf } from "vuelidate/lib/validators";

export default {
  name: "Dates",
  data() {
    const date = new Date();
    return {
      flatpickrConfig: {
        dateFormat: "d-m-Y",
        minDate: date.setDate(date.getDate() + 2),
        locale: Dutch
      }
    };
  },
  components: {
    flatPickr
  },
  mounted() {
    const date = new Date();
    if (this.typeTransport !== "verhuizing") {
      this.flatpickrConfig = {
        dateFormat: "d-m-Y",
        minDate: date.setDate(date.getDate() + 1),
        locale: Dutch
      };
    }
  },
  computed: {
    ...mapFields([
      "ophalendatum",
      "afleverdatum",
      "zelfdedag",
      "afleverTime",
      "ophalenTime",
      "typeTransport"
    ]),
    isNotSameDay() {
      return this.zelfdedag === "nee";
    }
  },
  methods: {
    nextStep() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.$root.goToNextRoute();
    }
  },
  validations: {
    ophalendatum: {
      required
    },
    ophalenTime: {
      required
    },
    zelfdedag: {
      required
    },
    afleverdatum: {
      requiredIf: requiredIf("isNotSameDay")
    },
    afleverTime: {
      requiredIf: requiredIf("isNotSameDay")
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  padding: 15px 20px;
  border: 1px solid var(--light-grey);
  margin-bottom: 10px;
}

.row-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 30px;
  margin-bottom: 24px;
}

.mt-2 {
  margin-top: 20px;
}

.btn.btn__filled.w-100 {
  margin-top: 20px;
}
</style>
